export default __webpack_public_path__ + "static/Chillax_Small-c1c3b2d21cd7465202d7e7702cd8449f.jpg";